import {Component, Input} from '@angular/core';
import moment from 'moment';
/**
 * Generated class for the EventCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'event-card',
  templateUrl: 'event-card.html'
})
export class EventCardComponent {

  @Input() public event: any = {};
  @Input() public showTitle: Boolean = true;
  @Input() public hideWinner: Boolean = false;

  constructor() {
  }
  limitTitle (title, limit = 20) {

    const newTitle = [];

    if(title.length > limit) {
      title.split(' ').reduce((acc, cur) => {
        if(acc + cur.length <= limit){
          newTitle.push(cur);
        }
        return acc + cur.length;
      }, 0);
      return `${newTitle.join(' ')}...`;
    }

    return title;
  }

  get endingPeriod(){
    return moment(this.event.end_date).diff(new Date, 'days')
  }

  get participants(){
    return this.event.participants || 100
  }

  get hasWinners(){
    return !!(this.event && this.event.winners && this.event.winners.length);
  }

  get ended(){
    return !!(this.event && this.event.status == 'closed');
  }
}



// WEBPACK FOOTER //
// ./src/components/event-card/event-card.ts